var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useSandbox, useBusiness } from '../Providers';
import { WarningChip } from '../../Chip';
export var OrderSummaryHeader = function (_a) {
    var hideHeader = _a.hideHeader, className = _a.className, children = _a.children;
    return (_jsx(Header, __assign({ className: className }, { children: hideHeader ? (_jsx(EnvironmentBadge, {})) : (_jsxs(_Fragment, { children: [_jsx(BusinessLogo, {}), _jsx(BusinessName, {}), _jsx(EnvironmentBadge, {}), _jsx(Right, { children: children })] })) })));
};
var Header = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-bottom: calc(var(--spacing) * 3);\n\n  h1 {\n    color: var(--checkout-gray800);\n    margin: 0 var(--spacing);\n    font-size: var(--checkout-font-size-14);\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: calc(var(--spacing) * 3);\n\n  h1 {\n    color: var(--checkout-gray800);\n    margin: 0 var(--spacing);\n    font-size: var(--checkout-font-size-14);\n  }\n"])));
var Right = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var BusinessName = function () {
    var businessName = useBusiness().businessName;
    return _jsx("h1", { children: businessName });
};
var BusinessLogo = function () {
    var _a = useBusiness(), businessLogo = _a.businessLogo, businessName = _a.businessName;
    return _jsx("img", { src: businessLogo, height: 28, width: 28, alt: businessName });
};
var EnvironmentBadge = function () {
    var isSandbox = useSandbox().isSandbox;
    if (!isSandbox)
        return null;
    return _jsx(WarningChip, { children: "Test Mode" });
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Header.js.map